import React, { useEffect, useState, memo } from 'react';
import { motion } from 'framer-motion';
import { EnhancedProductCard } from '../shared/EnhancedProductCard';
import { ZapIcon, ClockIcon, ArrowRightIcon } from 'lucide-react';
import { PRODUCT_IMAGES } from '../../data/productImages';
import { useHorizontalScroll } from '../../lib/hooks/useHorizontalScroll';
import { haptics } from '../../lib/utils/haptics';
export const FlashSales = memo(function FlashSales() {
  const {
    scrollContainerRef,
    currentSlide,
    isMobile,
    handleScroll,
    scrollToSlide
  } = useHorizontalScroll();
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 4,
    minutes: 57,
    seconds: 10
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          days,
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) {
          seconds--;
        } else {
          seconds = 59;
          if (minutes > 0) {
            minutes--;
          } else {
            minutes = 59;
            if (hours > 0) {
              hours--;
            } else {
              hours = 23;
              if (days > 0) {
                days--;
              }
            }
          }
        }
        return {
          days,
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const products = [{
    id: 1,
    name: 'Optimum Nutrition Gold Standard 100% Whey Protein',
    brand: 'Optimum Nutrition',
    price: 29.99,
    originalPrice: 69.99,
    discount: 62,
    rating: 4.8,
    reviewCount: 2456,
    image: PRODUCT_IMAGES[0],
    isBestSeller: true,
    isNew: false,
    expressDelivery: true
  }, {
    id: 2,
    name: 'C4 Original Pre-Workout Powder',
    brand: 'Cellucor',
    price: 24.99,
    originalPrice: 49.99,
    discount: 50,
    rating: 4.7,
    reviewCount: 1823,
    image: PRODUCT_IMAGES[1],
    isBestSeller: false,
    isNew: true,
    expressDelivery: true
  }, {
    id: 3,
    name: 'Dymatize ISO100 Hydrolyzed Protein',
    brand: 'Dymatize',
    price: 34.99,
    originalPrice: 64.99,
    discount: 46,
    rating: 4.9,
    reviewCount: 3102,
    image: PRODUCT_IMAGES[2],
    isBestSeller: true,
    isNew: false,
    expressDelivery: true
  }, {
    id: 4,
    name: 'MuscleTech Nitro-Tech Whey Protein',
    brand: 'MuscleTech',
    price: 27.99,
    originalPrice: 54.99,
    discount: 49,
    rating: 4.6,
    reviewCount: 1567,
    image: PRODUCT_IMAGES[3],
    isBestSeller: false,
    isNew: false,
    expressDelivery: true
  }, {
    id: 5,
    name: 'BSN Syntha-6 Protein Powder',
    brand: 'BSN',
    price: 31.99,
    originalPrice: 59.99,
    discount: 47,
    rating: 4.7,
    reviewCount: 2234,
    image: PRODUCT_IMAGES[4],
    isBestSeller: false,
    isNew: false,
    expressDelivery: true
  }, {
    id: 6,
    name: 'Optimum Nutrition Amino Energy',
    brand: 'Optimum Nutrition',
    price: 19.99,
    originalPrice: 34.99,
    discount: 43,
    rating: 4.5,
    reviewCount: 1890,
    image: PRODUCT_IMAGES[0],
    isBestSeller: false,
    isNew: true,
    expressDelivery: true
  }];
  const totalSlides = Math.ceil(products.length / 2);
  return <div className="w-full" data-id="element-2342" data-mp="2ilivdrpigeue">
      <div className="container mx-auto px-4" data-id="element-2343" data-mp="2imc7773btuje">
        <div className="bg-gradient-to-r from-red-600 to-orange-600 rounded-xl overflow-hidden mb-6" data-id="element-2344" data-mp="2nkm2risyqx5j">
          <div className="p-4 md:p-6 text-white" data-id="element-2345" data-mp="29tqnnorvfjti">
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center" data-id="element-2346" data-mp="29sz3da3q58ij">
              <div className="mb-4 md:mb-0" data-id="element-2347" data-mp="2dtiy670ts01i">
                <span className="text-xs font-bold text-white bg-white bg-opacity-20 px-2 py-0.5 rounded-full mb-2 inline-block uppercase" data-id="element-2348" data-mp="31kwtmlu9wbqp">
                  LIMITED TIME OFFERS
                </span>
                <h2 className="text-2xl md:text-3xl font-bold text-white flex items-center" data-id="element-2349" data-mp="1ims204kml9mo">
                  <ZapIcon className="w-6 h-6 md:w-8 md:h-8 mr-2" data-id="element-2350" data-mp="1do8i09ple7wy" />
                  FLASH SALES
                </h2>
              </div>
              <div className="flex items-center gap-4" data-id="element-2351" data-mp="18pngm6ylti6x">
                <div className="flex items-center gap-2 bg-white bg-opacity-20 rounded-full px-4 py-2" data-id="element-2352" data-mp="14naertmza4ff">
                  <ClockIcon className="w-4 h-4" data-id="element-2353" data-mp="21d9ty6xmw16z" />
                  <div className="flex items-center gap-1 font-mono font-bold" data-id="element-2354" data-mp="21d1jelozh7yy">
                    <span data-id="element-2355" data-mp="1wfhveu2hhgtt">{String(timeLeft.hours).padStart(2, '0')}</span>
                    <span data-id="element-2356" data-mp="1rn84pbtjocqh">:</span>
                    <span data-id="element-2357" data-mp="1rmf5cvwx0pid">{String(timeLeft.minutes).padStart(2, '0')}</span>
                    <span data-id="element-2358" data-mp="1nmy0o4pbbwe9">:</span>
                    <span data-id="element-2359" data-mp="1nlwcqzn77ff4">{String(timeLeft.seconds).padStart(2, '0')}</span>
                  </div>
                </div>
                <a href="#" className="text-white bg-white bg-opacity-20 hover:bg-opacity-30 px-4 py-2 rounded-full text-sm font-medium transition-colors flex items-center flex-shrink-0" data-id="element-2360" data-mp="2k5vngkl2jfoe">
                  View All
                  <ArrowRightIcon className="w-4 h-4 ml-1" data-id="element-2361" data-mp="6uazzbcc9mw7" />
                </a>
              </div>
            </div>
          </div>
        </div>
        {/* Mobile Slider */}
        {isMobile ? <div className="relative" data-id="element-2362" data-mp="fw0r0g2b6jtg">
            <div ref={scrollContainerRef} onScroll={handleScroll} className="flex overflow-x-auto snap-x snap-mandatory scrollbar-hide gap-3" style={{
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
          WebkitOverflowScrolling: 'touch'
        }} data-id="element-2363" data-mp="ktk4hdr6mskc">
              {products.map((product, idx) => <motion.div key={product.id} initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.05,
            duration: 0.4
          }} className="snap-start flex-shrink-0" style={{
            width: 'calc(50% - 6px)'
          }} data-id="element-2364" data-mp="13kk02xt6n0ml" data-mpi={idx}>
                  <EnhancedProductCard product={product} data-id="element-2365" data-mp="3neu3ghj43p1n" />
                </motion.div>)}
            </div>
            {/* Pagination Dots */}
            <div className="flex justify-center gap-2 mt-4" data-id="element-2366" data-mp="14hscdf2wecu">
              {Array.from({
            length: totalSlides
          }).map((_, index) => <button key={index} onClick={() => {
            haptics.selection();
            scrollToSlide(index);
          }} className={`h-2 rounded-full transition-all ${currentSlide === index ? 'w-6 bg-[#1E2B55]' : 'w-2 bg-gray-300'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-2367" data-mp="22ww4swyusqlv" data-mpi={index} />)}
            </div>
          </div> :
      // Desktop Grid
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4" data-id="element-2368" data-mp="3o4nbtw0sqri">
            {products.map((product, idx) => <motion.div key={product.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.05,
          duration: 0.4
        }} data-id="element-2369" data-mp="3quf4hpv5wo4e" data-mpi={idx}>
                <EnhancedProductCard product={product} data-id="element-2370" data-mp="1k3yxnp8igq4l" />
              </motion.div>)}
          </div>}
      </div>
    </div>;
});